import { MeasurementsQueryResult } from '../../../timeSeries/types'
import sumBy from 'lodash/sumBy'

export function getSeriesTotal(series: MeasurementsQueryResult[]): number | undefined {
    if (!series.length || series.some((s) => s.isLoading)) return undefined
    const measurements = series.flatMap((s) => s.data.measurements)
    if (!measurements.length) return undefined
    return sumBy(measurements, 'value')
}
